import { render, staticRenderFns } from "./promotion-box.vue?vue&type=template&id=43f18f42&scoped=true&"
import script from "./promotion-box.vue?vue&type=script&lang=js&"
export * from "./promotion-box.vue?vue&type=script&lang=js&"
import style0 from "./promotion-box.vue?vue&type=style&index=0&id=43f18f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f18f42",
  null
  
)

export default component.exports